import _ from 'lodash'
import { urls } from 'Src/constants/Urls'
import { axiosDS } from '@pp/axios'
import { SettingModel } from 'Models'

export const socketApi = {
	getTicket: async (user_id: number | string): Promise<SettingModel> => {
		const res = await axiosDS().get(urls.socket.ticket.replace(':id', user_id.toString()))
		return _.get(res, 'data.ticket', null)
	},
}
